import { FC, FormEvent } from "react";
import Modal from "components/Modal";
import { useForgotPassword } from "../model/useForgotPassword";

import styles from "./ForgotPasswordModal.module.css";

interface Props {
  onClose: () => void;
}

export const ForgotPasswordModal: FC<Props> = ({ onClose }) => {
  const { email, setEmail, submit, isSubmitting, errorMessage, isSent } =
    useForgotPassword();

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    submit();
  };

  return (
    <Modal isOpen onClose={onClose} title="Reset password">
      {isSent ? (
        <div className={styles.content}>
          <p className={styles.status}>
            A reset link has been sent to your email.
          </p>
          <button
            type="button"
            className={styles.submitButton}
            onClick={onClose}
          >
            Close
          </button>
        </div>
      ) : (
        <form className={styles.content} onSubmit={handleSubmit}>
          <p className={styles.hint}>
            Enter your account email and we&apos;ll send you a link to reset
            your password.
          </p>
          <input
            className={styles.input}
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="you@example.com"
            autoFocus
          />
          {errorMessage && <p className={styles.error}>{errorMessage}</p>}
          <button
            type="submit"
            className={styles.submitButton}
            disabled={isSubmitting || !email.trim()}
          >
            {isSubmitting ? "Sending..." : "Send reset link"}
          </button>
        </form>
      )}
    </Modal>
  );
};
